import { bus } from '../bus'

import SurveyTaskModel from './model/SurveyTask'
import SurveyTaskWindow from './windows/SurveyTaskWindow'

import MoveTaskModel from './model/MoveTask'
import MoveTaskWindow from './windows/MoveTaskWindow'

import TaskModel from './model/Task'
import TaskWindow from './windows/TaskWindow'

import CourierTaskModel from './model/CourierTask'
import CourierTaskWindow from './windows/CourierTaskWindow'

export default {
	map: {
		survey: {
			model: 	SurveyTaskModel,
			window: SurveyTaskWindow

		},
		move: {
			model: 	MoveTaskModel,
			window: MoveTaskWindow
		},
		general: {
			model: 	TaskModel,
			window: TaskWindow
		},
		courier: {
			model: 	CourierTaskModel,
			window: CourierTaskWindow
		}
	},
	async open(comp, type, id) {
		var self 	= comp;
		var types 	= (await comp.axios.get('/tasks/types/')).data._items;
		type		= types.find(function (item) { return item.name == type; });
		var set		= this.map[type.super];

		

		var model	= set.model;
		var win 	= set.window;
		var ent 	= id ? await model.read(self.axios, id) : model.entity();

		if (!id) {
			ent.employee_id 		= self.$store.state.employee.id;
			ent.department_id 		= self.$store.state.employee.department_id;
			ent._embedded.employee	= self.$store.state.employee;
			ent.type				= type;
		}

		self.$store.state.windowStack.push(win, {
			value: ent,
			async submit(entity) {
				if (await model.save(self.axios, entity)) {
					self.$store.state.windowStack.pop();
					bus.$emit('update');
				}
			}
		});
	},
	async opn(comp, item) {
		

		var self 	= comp;
		var types 	= (await comp.axios.get('/tasks/types/')).data._items;
		var type	= types.find(function (itm) { return itm.name == item.type; });
		var set		= this.map[type.super];

		

		var model	= set.model;
		var win 	= set.window;
		var ent 	= item.id ? await model.read(self.axios, item.id) : model.entity();

		if (!item.id) {
			ent.employee_id 		= self.$store.state.employee.id;
			ent.department_id 		= self.$store.state.employee.department_id;
			ent._embedded.employee	= self.$store.state.employee;
			ent.type				= type;
		}

		self.$store.state.windowStack.push(win, {
			value: ent,
			async submit(entity) {
				if (await model.save(self.axios, entity)) {
					self.$store.state.windowStack.pop();
					bus.$emit('update');
				}
			}
		});
	},
	async close(comp, item) {
		
		await comp.axios.put('/planning/tasks/' + item.id + '/close/');
		bus.$emit('update');
	},
	async printPrivate(comp, item) {
		
		window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/private/print/?token=' + comp.$store.state.auth);
	},
	async printBusiness(comp, item) {
		
		window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/business/print/?token=' + comp.$store.state.auth);
	}
};